import React, { useRef, useState } from 'react'
import { Color, Theme } from '@opallabs/gem'
import { ThemeProvider } from '@opallabs/hooks'
import { Button, Icon, Popover } from '@opallabs/lapidary'
import ContentDetails from './ContentDetails'
import type { Label } from './ContentDetails/LabelDetails'
import type { PostOption } from './ContentDetails/PostOptionDetails'

import './styles.scss'

export type ContentDetailsPopoverProps = {
  budget: {
    id: string
    value: string
  }
  getBudget: (options: { id: number; context: 'post' }) => void
  id: number
  labels: Array<Label>
  postOptions: Array<PostOption>
  theme: Theme
}

export const ContentDetailsPopover: React.FC<ContentDetailsPopoverProps> = ({
  budget,
  getBudget,
  labels,
  id,
  postOptions,
  theme,
}) => {
  const [open, setOpen] = useState(false)
  // Legacy moment pages mount one popover per content card, and few are
  // opened, so the budget is fetched on the first open instead of on mount.
  const hasFetchedBudget = useRef(false)

  const onOpenChange = (nextOpen: boolean) => {
    setOpen(nextOpen)
    if (nextOpen && !hasFetchedBudget.current) {
      hasFetchedBudget.current = true
      getBudget({ id, context: 'post' })
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Popover.Root open={open} onOpenChange={onOpenChange}>
        <Popover.Trigger
          tooltip={{ content: 'Content Details', zIndex: 9999 }}
          legacyTheme={theme}
          open={open}
        >
          <Button
            name="Content details"
            icon={
              <Icon
                glyph="gem-content-outlined"
                color={Color[theme].Icon.Secondary}
              />
            }
            theme={theme}
            variant="ghost"
          />
        </Popover.Trigger>
        <Popover.Content showArrow={true} zIndex={9999}>
          <ContentDetails
            budget={budget.value}
            labels={labels}
            postOptions={postOptions}
          />
        </Popover.Content>
      </Popover.Root>
    </ThemeProvider>
  )
}
